import request from '@/utils/request'
// 报名列表
export function getSupplierRegistrationList(params) {
  return request({
    url: '/web/Supplier/list',
    method: 'get',
    params
  });
}

// 供应商
// 报名列表
export function getProjectList(data) {
  return request({
    url: '/web/Supplier/MyProject',
    method: 'get',
    params:data
  });
}
// 能否报名
export function getSupplierCanRegister(data) {
  return request({
    url: '/web/Supplier/CanRegister',
    method: 'get',
    params:data
  });
}
// 报名
export function postAddProjectSupplier(data) {
  return request({
    url: '/web/Supplier/AddProjectSupplier',
    method: 'post',
    data
  });
}

// 项目 流程节点
export function getProjectFlowNodes(params) {
  return request({
    url: '/web/Supplier/ProjectFlowNodes',
    method: 'get',
    params
  });
}

// 项目 公告查询 某一个类型的公告
export function getProjectNoticeByProjectId(params) {
  return request({
    url: '/web/Supplier/GetProjectNoticeByProjectId',
    method: 'get',
    params
  });
}

// 子账户管理
// 子账户列表 (仅主账户可查, 返回本主账户下所有子账户)
export function getChildAccountList() {
  return request({
    url: '/web/Supplier/SubAccountList',
    method: 'get'
  })
}
// 子账户列表分页 (仅主账户可查, 返回本主账户下所有子账户)
export function getChildAccountPage(params) {
  return request({
    url: '/web/Supplier/SubAccountPage',
    method: 'get',
    params
  })
}
// 子账户新增 (仅主账户可操作)
export function createChildAccount(data) {
  return request({
    url: '/web/Supplier/SubAccountAdd',
    method: 'post',
    data
  })
}

// 子账户修改 (仅主账户可操作)
export function updateChildAccount(data) {
  return request({
    url: '/web/Supplier/SubAccountUpdate',
    method: 'post',
    data
  })
}

// 子账户删除 (仅主账户可操作, 软删)
export function deleteChildAccount(data) {
  return request({
    url: '/web/Supplier/SubAccountDelete/' + data.id,
    method: 'delete',
    params: data
  })
}




